import React from 'react';
import { IConfigComponent } from '@ts/ui-models';
import GlobalDataGrid, { generateConfigComponent } from '@modules/dataGrid/GlobalDataGrid';

export const defaultConfigComponent: IConfigComponent = generateConfigComponent('ruleset');

interface IRulesetsProps {
  inheritedProps?: any;
}

const Rulesets = (props: IRulesetsProps) => {
  return <GlobalDataGrid configComponent={defaultConfigComponent} inheritedProps={props.inheritedProps} />;
};

export default Rulesets;
